import { useTranslation } from 'react-i18next'

import { PageHeader } from '@/components/ui/PageHeader'

import { VehicleAnalyticsDisplay } from './components/VehicleAnalyticsDisplay'
import { VehicleAnalyticsFilters } from './components/VehicleAnalyticsFilters'

export default function VehicleAnalyticsPage() {
  const { t } = useTranslation()

  return (
    <div className="p-5 space-y-5">
      <PageHeader
        title={t('nav.vehicle_analytics')}
        subtitle={t('vehicle_analytics.subtitle')}
      />

      <VehicleAnalyticsFilters />
      <VehicleAnalyticsDisplay />
    </div>
  )
}
